import { useMemo } from 'react';

import { PropsWithClassName } from '@/types';
import { ColorKey } from '@/types/colors';
import { COLORS } from '@/utils/constants';

interface IconAtentionProps extends PropsWithClassName {
  color: ColorKey;
}

export const IconAtention: React.FC<IconAtentionProps> = ({
  color,
  className,
}) => {
  const getColor = useMemo(() => {
    return (colorPath: ColorKey): string => {
      try {
        const result = colorPath.split('.').reduce((obj: any, key) => {
          return obj[key as keyof typeof obj];
        }, COLORS);

        if (typeof result !== 'string') {
          throw new Error('Invalid color path');
        }

        return result;
      } catch (error) {
        console.error(`Error getting color for path ${colorPath}:`, error);
        return COLORS['gdt-gray'].DEFAULT; // Fallback color
      }
    };
  }, []);
  return (
    <svg
      className={className}
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M7.89623 1.71223C8.2332 1.52252 8.61337 1.42285 9.00008 1.42285C9.38678 1.42285 9.76695 1.52252 10.1039 1.71223C10.4409 1.90195 10.7233 2.17531 10.9238 2.50594L10.926 2.5095L17.2785 13.1145L17.2846 13.1249C17.481 13.4651 17.585 13.8508 17.5861 14.2437C17.5872 14.6366 17.4854 15.0229 17.2908 15.3642C17.0963 15.7055 16.8158 15.99 16.4771 16.1892C16.1385 16.3884 15.7537 16.4955 15.3608 16.4999L15.3526 16.5L2.63933 16.4999C2.24648 16.4956 1.86161 16.3884 1.52301 16.1892C1.1844 15.99 0.903866 15.7055 0.709314 15.3642C0.514761 15.0229 0.412971 14.6366 0.414071 14.2437C0.415171 13.8508 0.519123 13.4651 0.715584 13.1249L0.721676 13.1145L7.07418 2.50951L7.71756 2.8949L7.07633 2.50594C7.27688 2.17531 7.55926 1.90195 7.89623 1.71223ZM8.35973 3.28239L2.01209 13.8793C1.94821 13.9916 1.91443 14.1186 1.91407 14.2479C1.9137 14.3789 1.94763 14.5076 2.01248 14.6214C2.07733 14.7352 2.17084 14.83 2.28371 14.8964C2.39559 14.9622 2.52262 14.9979 2.65237 14.9999H15.3478C15.4775 14.9979 15.6046 14.9622 15.7164 14.8964C15.8293 14.83 15.9228 14.7352 15.9877 14.6214C16.0525 14.5076 16.0865 14.3789 16.0861 14.2479C16.0857 14.1186 16.052 13.9917 15.9881 13.8793L9.64133 3.28388C9.64102 3.28338 9.64072 3.28288 9.64042 3.28239C9.57362 3.17285 9.47984 3.08226 9.36802 3.01931C9.2557 2.95607 9.12898 2.92285 9.00008 2.92285C8.87118 2.92285 8.74445 2.95607 8.63213 3.01931C8.52031 3.08226 8.42653 3.17285 8.35973 3.28239Z"
        fill={getColor(color)}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M8.25 12.75C8.25 12.3358 8.58579 12 9 12H9.0075C9.42171 12 9.7575 12.3358 9.7575 12.75C9.7575 13.1642 9.42171 13.5 9.0075 13.5H9C8.58579 13.5 8.25 13.1642 8.25 12.75Z"
        fill={getColor(color)}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M9 6C9.41421 6 9.75 6.33579 9.75 6.75V9.75C9.75 10.1642 9.41421 10.5 9 10.5C8.58579 10.5 8.25 10.1642 8.25 9.75V6.75C8.25 6.33579 8.58579 6 9 6Z"
        fill={getColor(color)}
        fillRule="evenodd"
      />
    </svg>
  );
};
